"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefaultChoicesChanged = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
function isDefaultChoicesChanged(field) {
    const fieldType = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    const defaultChoices = fieldType === null || fieldType === void 0 ? void 0 : fieldType.params.choices;
    const fieldChoices = field.params.choices;
    if (defaultChoices.length !== (fieldChoices === null || fieldChoices === void 0 ? void 0 : fieldChoices.length)) {
        return true;
    }
    const choicesMap = fieldChoices.reduce((result, choice) => {
        result[choice.value] = choice;
        return result;
    }, {});
    return defaultChoices.some((defaultChoice) => {
        const choice = choicesMap[defaultChoice.value];
        return !(0, react_fast_compare_1.default)(defaultChoice, choice);
    });
}
exports.isDefaultChoicesChanged = isDefaultChoicesChanged;
